<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Pedidos" :tabs="tabs">
        <v-layout row wrap>
          <v-flex offset-md6 md5>
            <v-text-field xs12 sm6 md3
              label="Pesquisar pedidos"
              v-model="searchOrders"
              class="searchInput"
              append-icon="search">
            </v-text-field>
          </v-flex>
        </v-layout>
      </sub-tabs>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
export default {
  name: 'Pedidos',
  components: {
    'sub-tabs': subTabs
  },
  data () {
    return {
      tabs: [
        {
          nome: 'Novos',
          url: 'Novos'
        },
        {
          nome: 'Andamento',
          url: 'Andamento'
        },
        {
          nome: 'Concluídos',
          url: 'Concluidos'
        },
        {
          nome: 'Cancelados',
          url: 'Cancelados'
        }
      ]
    }
  },
  computed: {
    searchOrders: {
      get () {
        return this.$store.getters.searchOrders
      },
      set (value) {
        this.$store.commit('updateSearchOrders', value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?6edede59